const serviceAreas = [
  "San Rafael", "Point Richmond", "Mill Valley", "San Anselmo",
  "Fairfax", "Corte Madera", "Tiburon", "Novato",
  "Petaluma", "Berkeley", "Oakland", "Richmond",
  "El Cerrito", "San Francisco", "Marin County", "East Bay Region",
];

export default function LocationDetail() {
  const handleScroll = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="bg-[#0F0F0F] py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Our Two Facilities
          </p>
          <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold mb-4">
            Vehicle Storage Near You
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto mb-6"></div>
          <p className="font-sans text-[#9A9A9A] text-base max-w-xl mx-auto leading-relaxed">
            Whether you&apos;re in Marin County or the East Bay, Don Collins has a secure indoor facility conveniently located for Bay Area collectors and vehicle owners.
          </p>
        </div>

        {/* Two Location Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Location 1 — San Rafael */}
          <div className="bg-charcoal-200 rounded-lg overflow-hidden border border-white/5 hover:border-gold/25 transition-colors">
            <div className="w-full h-56 overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3148.9!2d-122.5311!3d37.9735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085976bc01a55bb%3A0x55a0e4e18a45ef5a!2sSan+Rafael%2C+CA!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus"
                width="100%"
                height="224"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Don Collins Auto Storage - San Rafael Location"
              ></iframe>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-lg">
                  <i className="ri-map-pin-2-fill text-gold text-lg"></i>
                </div>
                <span className="font-sans text-gold text-xs tracking-[0.2em] uppercase font-semibold">
                  Primary Location
                </span>
              </div>
              <h3 className="font-serif text-white text-2xl font-semibold mb-2">
                San Rafael, CA
              </h3>
              <p className="font-sans text-[#9A9A9A] text-sm mb-5 leading-relaxed">
                Irwin St, San Rafael, CA — central Marin County. Convenient for San Francisco, Sausalito, Mill Valley, Novato, and surrounding Marin communities.
              </p>
              <ul className="space-y-3 mb-6">
                {[
                  { icon: "ri-phone-line", text: "(415) 453-9180 — Office", href: "tel:4154539180" },
                  { icon: "ri-smartphone-line", text: "(415) 846-4281 — Jim Long Cell", href: "tel:4158464281" },
                  { icon: "ri-mail-line", text: "doncollinsstorage@gmail.com", href: "mailto:doncollinsstorage@gmail.com" },
                  { icon: "ri-time-line", text: "Open Daily — By Appointment", href: "" },
                ].map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <div className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0">
                      <i className={`${item.icon} text-sm`}></i>
                    </div>
                    {item.href ? (
                      <a href={item.href} className="font-sans text-sm text-[#C8C8C8] hover:text-gold transition-colors cursor-pointer">
                        {item.text}
                      </a>
                    ) : (
                      <span className="font-sans text-sm text-[#C8C8C8]">{item.text}</span>
                    )}
                  </li>
                ))}
              </ul>
              <div className="p-4 bg-charcoal-300 rounded-lg border border-gold/10">
                <p className="font-sans text-xs text-[#9A9A9A] leading-relaxed">
                  <strong className="text-white">Areas Served:</strong> San Rafael, Mill Valley, San Anselmo, Fairfax, Corte Madera, Tiburon, Sausalito, Novato, San Francisco, and all of Marin County.
                </p>
              </div>
            </div>
          </div>

          {/* Location 2 — Point Richmond */}
          <div className="bg-charcoal-200 rounded-lg overflow-hidden border border-white/5 hover:border-gold/25 transition-colors">
            <div className="w-full h-56 overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.5!2d-122.3767!3d37.9144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80857dda59e2b19f%3A0x1f43c84b8c8b9f1a!2sPoint+Richmond%2C+Richmond%2C+CA!5e0!3m2!1sen!2sus!4v1710000000001!5m2!1sen!2sus"
                width="100%"
                height="224"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Don Collins Auto Storage - Point Richmond Location"
              ></iframe>
            </div>
            <div className="p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-lg">
                  <i className="ri-map-pin-2-fill text-gold text-lg"></i>
                </div>
                <span className="font-sans text-gold text-xs tracking-[0.2em] uppercase font-semibold">
                  East Bay Location
                </span>
              </div>
              <h3 className="font-serif text-white text-2xl font-semibold mb-2">
                Point Richmond, CA
              </h3>
              <p className="font-sans text-[#9A9A9A] text-sm mb-5 leading-relaxed">
                Canal Blvd, Point Richmond, CA — near the Standard Oil Refinery. Approximately 9 miles / 15 minutes from San Rafael. Convenient for Berkeley, Oakland, Richmond, and East Bay communities.
              </p>
              <ul className="space-y-3 mb-6">
                {[
                  { icon: "ri-phone-line", text: "(415) 453-9180 — Office", href: "tel:4154539180" },
                  { icon: "ri-smartphone-line", text: "(415) 846-4281 — Jim Long Cell", href: "tel:4158464281" },
                  { icon: "ri-mail-line", text: "doncollinsstorage@gmail.com", href: "mailto:doncollinsstorage@gmail.com" },
                  { icon: "ri-time-line", text: "Open Daily — By Appointment", href: "" },
                ].map((item) => (
                  <li key={item.text} className="flex items-center gap-3">
                    <div className="w-4 h-4 flex items-center justify-center text-gold flex-shrink-0">
                      <i className={`${item.icon} text-sm`}></i>
                    </div>
                    {item.href ? (
                      <a href={item.href} className="font-sans text-sm text-[#C8C8C8] hover:text-gold transition-colors cursor-pointer">
                        {item.text}
                      </a>
                    ) : (
                      <span className="font-sans text-sm text-[#C8C8C8]">{item.text}</span>
                    )}
                  </li>
                ))}
              </ul>
              <div className="p-4 bg-charcoal-300 rounded-lg border border-gold/10">
                <p className="font-sans text-xs text-[#9A9A9A] leading-relaxed">
                  <strong className="text-white">Areas Served:</strong> Point Richmond, Berkeley, Oakland, El Cerrito, Richmond, Emeryville, and the greater East Bay region.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Service Area Tags */}
        <div className="bg-charcoal-200 rounded-lg p-8 border border-white/5 mb-10">
          <div className="text-center mb-6">
            <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-2">Coverage Map</p>
            <h3 className="font-serif text-white text-2xl font-semibold">Areas We Serve</h3>
          </div>
          <div className="flex flex-wrap justify-center gap-2">
            {serviceAreas.map((area) => (
              <span
                key={area}
                className="font-sans text-xs text-[#C8C8C8] bg-charcoal-300 border border-white/10 px-3 py-1.5 rounded-full"
              >
                {area}
              </span>
            ))}
          </div>
          <p className="font-sans text-[#666] text-xs mt-5 italic text-center">
            Serving San Francisco, Marin County, the East Bay and beyond.
          </p>
        </div>

        {/* CTA Strip */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6 bg-charcoal-300 rounded-lg border border-gold/15 px-8 py-6">
          <div>
            <p className="font-sans text-white font-medium text-base">Ready to store your vehicle?</p>
            <p className="font-sans text-[#9A9A9A] text-sm mt-1">Call first to confirm availability — storage is by appointment.</p>
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <a
              href="tel:4154539180"
              className="font-sans text-sm font-semibold border border-gold text-gold px-6 py-3 rounded hover:bg-gold hover:text-charcoal transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              (415) 453-9180
            </a>
            <button
              onClick={handleScroll}
              className="font-sans text-sm font-semibold bg-gold text-charcoal px-6 py-3 rounded hover:bg-gold-light transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Reserve Online
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
